export default __webpack_public_path__ + "static/media/SELLOS_01.5c93141c.png";